<div class="loader-background">
	<img class="background" alt="background" [src]="loginBg" />
</div>

<div class="about-wrapper">
	<div class="title-wrapper">
		<div class="logo-icon">
			<img alt="logo" [src]="appLogo" />
		</div>
	</div>

	<div class="version-container">
		<h2>Version Details</h2>
		<p>
			FrontEnd Version: <strong>{{ feVersion }} </strong>
		</p>
		<p>
			BackendEnd Version: <strong>{{ beVersion }}</strong>
		</p>
		<!-- <app-tableau-dashboard/> -->
		<div class="text-container">
			<p>
				<strong>Elastic Health : </strong>
			</p>
			<p [ngStyle]="{ color: getColor(elasticHealth) }">
				<strong class="ehy"> {{ elasticHealth }}</strong>
			</p>
		</div>

		<!-- <p><strong>Description:</strong> {{ versionInfo?.description }}</p> -->
	</div>
</div>

<!-- <div *ngIf="isLoading">
    Loading version details...
  </div> -->
